
const imageExtensions = ['jpg', 'jpeg', 'gif', 'png', 'svg', 'bmp'];

const validExtensions = ['jpg', 'psd', 'ai', 'svg', 'pdf', 'jpeg', 'png', 'gif'];

const mimeTypesMap = {
	'image/jpg': 'jpg',
	'image/vnd.adobe.photoshop': 'psd',
	'application/illustrator': 'ai',
	'application/sru+xml': 'svg',
	'application/pdf': 'pdf',
	'image/jpeg': 'jpeg',
	'image/png': 'png',
	'image/gif': 'gif',
};

export const base64MimeType = (encoded) => {
	let result = null;

	if (typeof encoded !== 'string') {
		return result;
	}

	const mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

	if (mime && mime.length) {
		result = mime[1];
	}

	return result;
};

export const getImageExtensions = () => imageExtensions;

export const getSizeDescription = (bytes, decimals = 2) => {
	if (bytes === 0) {
		return '0 Bytes';
	}
	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	return `${parseFloat((bytes / (k ** i)).toFixed(dm))} ${sizes[i]}`;
};

export const getExtensionByMimeType = mimeType => mimeTypesMap[mimeType];

export const getExtensionByBase64 = codeBase64 => getExtensionByMimeType(
	base64MimeType(codeBase64),
);

export const base64ToBlob = (file) => {
	const byteString = atob(file.split(',')[1]);
	const ab = new ArrayBuffer(byteString.length);
	const ia = new Uint8Array(ab);

	for (let i = 0; i < byteString.length; i += 1) {
		ia[i] = byteString.charCodeAt(i);
	}

	return new Blob([ab], { type: base64MimeType(file) });
};

export const isImageExtension = extension => imageExtensions.includes(extension);

export const isValidExtension = extension => validExtensions.includes(extension);

export const isMimeTypeImage = mimeType => isImageExtension(mimeTypesMap[mimeType]);

export const isValidMimeType = mimeType => isValidExtension(mimeTypesMap[mimeType]);

export const isFileUrlImageBase64 = codeBase64 => isImageExtension(
	getExtensionByBase64(codeBase64),
);

const file = {
	base64ToBlob,
	base64MimeType,
	getExtensionByMimeType,
	getExtensionByBase64,
	getImageExtensions,
	getSizeDescription,
	isFileUrlImageBase64,
	isImageExtension,
	isMimeTypeImage,
	isValidExtension,
	isValidMimeType,
};

export default file;
